// Shared constants for the SIFT app

export const API = process.env.REACT_APP_BACKEND_URL;

export const TONES = [
  { id: "minimal",    label: "Minimal",    sub: "Clean, understated - let the product speak" },
  { id: "luxury",     label: "Luxury",     sub: "Elevated, aspirational, premium feel" },
  { id: "streetwear", label: "Streetwear", sub: "Bold, cultural, community-driven" },
  { id: "technical",  label: "Technical",  sub: "Spec-forward, performance-focused, precise" },
  { id: "editorial",  label: "Editorial",  sub: "Fashion-forward, narrative-led, artistic" },
];

export const STEPS = [
  { num: "01", label: "Setup" },
  { num: "02", label: "Search Intel" },
  { num: "03", label: "Audit" },
  { num: "04", label: "Feed Review" },
  { num: "05", label: "GMC Fix", optional: true },
  { num: "06", label: "Review" },
  { num: "07", label: "Done" },
];

// Colours
export const G      = "#2a6b45";
export const GL     = "#eef6f1";
export const GB     = "#c8e0d0";
export const BLACK  = "#1a1a1a";
export const MID    = "#555555";
export const LIGHT  = "#999999";
export const BORDER = "#e0e0e0";
export const BG     = "#ffffff";
export const PAGE   = "#e8e8e8";

// Industry benchmarks
export const BENCHMARKS = {
  AOV:       120,
  SEO_CTR:   0.27,
  PLA_CTR:   0.0086,
  CVR:       0.008,
  USING_REAL: false,
};

export const calcRevenue = (impBefore, impAfter) => {
  const seoBlend = 0.7, plaBlend = 0.3;
  const clkBefore = Math.round(impBefore * (seoBlend * BENCHMARKS.SEO_CTR + plaBlend * BENCHMARKS.PLA_CTR));
  const clkAfter  = Math.round(impAfter  * (seoBlend * BENCHMARKS.SEO_CTR + plaBlend * BENCHMARKS.PLA_CTR));
  const extraClicks = Math.max(0, clkAfter - clkBefore);
  return {
    clkBefore,
    clkAfter,
    extraClicks,
    revenue: Math.round(extraClicks * BENCHMARKS.CVR * BENCHMARKS.AOV),
  };
};

export const calcPriority = (p) => {
  const gap     = (100 - p.feedScore) / 100;
  const sigRich = Math.min(Object.values(p.signals).reduce((a,b) => a+b, 0) / 50, 1);
  const rev     = Math.min(p.impact.revenue / 2000, 1);
  const score   = Math.round((gap * 0.4 + sigRich * 0.35 + rev * 0.25) * 100);
  return score >= 70 ? { label: "High",   color: "#dc2626", bg: "#fef2f2", border: "#fecaca", score }
       : score >= 45 ? { label: "Medium", color: "#d97706", bg: "#fffbeb", border: "#fde68a", score }
       :               { label: "Low",    color: "#6b7280", bg: "#f9fafb", border: BORDER,    score };
};

export const sigConfidence = (sources) =>
  sources.length >= 4 ? "Very high" : sources.length >= 3 ? "High" : sources.length >= 2 ? "Medium" : "Single source";
